import { tokenUtility, useAuth, useUserId } from '@fluentsms/auth';
import { config } from '@fluentsms/graphql';
import { Realtime } from '@fluentsms/lib-subscriptions';
import cuid from 'cuid';
import React, { useMemo } from 'react';
import { ChannelsProvider } from './ChannelsProvider';
import { UserEventContextProvider } from './contexts';

export const AblyContext = React.createContext<{ client: Realtime | null; debugEnabled: boolean }>({
  client: null,
  debugEnabled: false,
});

export const AblyProvider = ({ children, enableDebug }: { children: React.ReactNode; enableDebug?: boolean }) => {
  const { isAuthenticated } = useAuth();
  const userId = useUserId();
  const authed = isAuthenticated();
  const client = useMemo(() => {
    if (authed && userId) {
      return new Realtime({
        authCallback: async (_, callback) => {
          try {
            const idToken = tokenUtility.getIdToken();
            const accessToken = tokenUtility.getAccessToken();
            const headers = {
              Authorization: `Bearer ${accessToken}`,
              'correlation-object': JSON.stringify({
                idToken: idToken ?? '',
                correlationId: cuid(),
              }),
            };
            const res = await fetch(`${config.uri}/subscriptions/auth`, { headers, method: 'POST' });
            const data = await res.json();
            callback(null, data);
          } catch (err) {
            callback(err, null);
          }
        },
      });
    }

    return null;
  }, [authed, userId]);

  return authed && userId ? (
    <AblyContext.Provider value={{ client, debugEnabled: enableDebug ?? false }}>
      <ChannelsProvider>
        <UserEventContextProvider userId={userId}>{children}</UserEventContextProvider>
      </ChannelsProvider>
    </AblyContext.Provider>
  ) : (
    <>{children}</>
  );
};
